import { userAction, portalAction } from 'root/redux/action';
import { setCurrentLanguageByKey } from 'root/redux/slice/language-slice';

import { ctu_getAgentCorrectComponent, ctu_getCorrectComponent, ctu_getTemplateKey } from './component-template-util';
import { gu_copy, gu_getNestedValue, gu_showHomeWithoutUrl, gu_changeLanguageArrangementSort, gu_proceedNestedObjectWithVM } from './general-util';

const core = {
    getCorrectComponent(allComponent, type, viewType, vm) {
        if (!allComponent) {
            return;
        }
        return ctu_getCorrectComponent(allComponent, type, viewType, vm);
    },

    // start --- used for old footer only (remove soon)
    getCustomFunction(customFunctions, type, viewType) {
        let templateKey = ctu_getTemplateKey(type, viewType);
        customFunctions = core.getCustomFunctions(customFunctions, viewType);
        if (templateKey && window[templateKey] && customFunctions[window[templateKey]]) {
            return customFunctions[window[templateKey]];
        } else {
            return customFunctions['default'];
        }
    },

    getCustomFunctions(customFunctions, viewType) {
        let isMobile = false;
        if (viewType === 'mobile') {
            isMobile = true;
        }

        if (customFunctions.desktop && customFunctions.mobile) {
            return isMobile ? customFunctions.mobile : customFunctions.desktop;
        } else {
            // fallback use old implementation
            return customFunctions;
        }
    },
    // end --- used for old footer only (remove soon)

    getAgentCorrectComponent(allComponent, type, viewType) {
        ctu_getAgentCorrectComponent(allComponent, type, viewType);
    },

    getCurrentLanguage(capitalCountryLanguage = true, setLanguage = false, vm, languageAction, basicInfo) {
        return new Promise((resolve) => {
            window.SPL_Content.getLanguageList(vm.props).then((languageListJson) => {
                const allowUserAccessOtherCurrency = !!gu_proceedNestedObjectWithVM(vm, vm?.props?.portal?.settings?.allowUserAccessOtherCurrency);
                let user = vm.props.user;
                let account = basicInfo || user.account;
                let portalSettings = vm.props.portalSettingsReducer?.portalSettings;
                let memberCurrency = null;
                let massagedCountryLanguageKey = null;

                if (account && window.SPL_Auth.isAuthenticated()) {
                    memberCurrency = account.actualCurrency ? account.actualCurrency : account.currency;
                }

                let pathname = window.location.pathname;
                let localStorageLanguage = window.localStorage.getItem('LANGUAGE_CURRENCY');
                let pathArray = pathname.split('/');
                let previousLanguage = '';
                let computeLanguage = '';
                let langObj = {};
                let queryStr = window.SPL_Cookie.getCookie('queryStr');
                let searchPath = window.SPL_Handler.parse_query_string(queryStr);
                const hostname = window.location.hostname;
                const languageDomainsSetting = Object.entries(portalSettings?.languageDomains || {}).find(([, domain]) => domain?.includes(hostname))?.[0];

                // the setting for this part is used for filter the window.languageList
                // is also used for set the massaged Language, to prevent user hardcode url change language to affect the language
                // for e.g. if your portal is only got en-th, th-th, but url changed to zh-my, it will eat the default language
                if (portalSettings?.features?.customRegionDefaultLangKey) {
                    let region = portalSettings?.features?.customRegionDefaultLangKey;
                    let globalCurrency = languageListJson.find(function (a) {
                        let globalCountry = a.languages.filter(function (b) {
                            if (account && account.country) {
                                if (b.countryCode.toLowerCase() === account.country.toLowerCase()) {
                                    return b.countryCode.toLowerCase() === account.country.toLowerCase();
                                } else {
                                    // if cant found, return international country code
                                    // suppose if countryCode cant match then will be international country case only
                                    return b.countryCode.toLowerCase() === 'us';
                                }
                            } else {
                                return b.currency === memberCurrency;
                            }
                        });
                        return globalCountry.length > 0;
                    });
                    if (globalCurrency) {
                        let tempLanguageList = [];
                        for (let i = 0; i < globalCurrency.languages.length; i++) {
                            let countryLanguageKey =
                                globalCurrency.languages[i].countryLanguageKey && globalCurrency.languages[i].countryLanguageKey.toLowerCase().replace('_', '-');
                            tempLanguageList.push(countryLanguageKey);
                        }
                        window.languageList = tempLanguageList;

                        let countryLanguage = globalCurrency.languages.find(function (a) {
                            return a.key === region[a.countryName];
                        });
                        massagedCountryLanguageKey = countryLanguage.countryLanguageKey;
                    }
                }

                if (searchPath.lang !== undefined && window.languageList.filter((b) => b === searchPath.lang.toLowerCase().replace('_', '-')).length > 0) {
                    computeLanguage = searchPath.lang;
                    delete searchPath.lang;
                    window.SPL_Handler.storeQueryStringToPlainText(searchPath);
                } else if (
                    pathArray.length >= 2 &&
                    pathArray[1].indexOf('-') !== -1 &&
                    window.languageList &&
                    window.languageList.filter((a) => a === pathArray[1]).length > 0
                ) {
                    // 1st check for url contains country language or not
                    computeLanguage = pathArray[1];
                } else if (
                    !allowUserAccessOtherCurrency &&
                    massagedCountryLanguageKey &&
                    pathArray.length >= 2 &&
                    pathArray[1].indexOf('-') !== -1 &&
                    pathArray[1] !== (massagedCountryLanguageKey && massagedCountryLanguageKey.toLowerCase() && massagedCountryLanguageKey.toLowerCase().replace('_', '-'))
                ) {
                    // if customRegionDefaultLangKey null skip this
                    // check if got the customRegionDefaultLangKey and the url not match with it.
                    computeLanguage = massagedCountryLanguageKey.toLowerCase().replace('_', '-');
                } else if (localStorageLanguage && !languageDomainsSetting) {
                    // 2nd check for localstorage contains last language
                    computeLanguage = localStorageLanguage;
                } else if (languageDomainsSetting) {
                    computeLanguage = languageDomainsSetting;
                } else {
                    // 3rd fallback use default language
                    computeLanguage = window.countryLanguageKey;
                }

                // make sure language is big capital and convert - to _
                computeLanguage = computeLanguage.toUpperCase().replace('-', '_');
                previousLanguage = computeLanguage;

                // if got member currency mean login , only display member currency related language
                if (!allowUserAccessOtherCurrency && memberCurrency) {
                    if (portalSettings?.features?.languageModalOrdering) {
                        let sort = gu_changeLanguageArrangementSort(portalSettings?.features?.languageModalOrdering, languageListJson);
                        if (sort) {
                            languageListJson = sort;
                        }
                    }

                    if (portalSettings?.features?.extraLanguage) {
                        languageListJson.push(portalSettings?.features?.extraLanguage);
                    }

                    if (languageListJson.length > 0) {
                        let supportedLanguage = null;
                        let filterLanguage = null;

                        // supportedLanguage = languageListJson.filter(function (a) {
                        //     let globalCountry = a.languages.filter(function (b) {
                        //         return b.countryLanguageKey.toLowerCase() === computeLanguage.toLowerCase();
                        //     });

                        //     return globalCountry.length > 0;
                        // });

                        supportedLanguage = languageListJson.filter((list) => list.currency === memberCurrency);

                        filterLanguage =
                            supportedLanguage &&
                            supportedLanguage[0] &&
                            supportedLanguage[0].languages &&
                            supportedLanguage[0].languages.filter((sLang) => sLang.countryLanguageKey === computeLanguage);

                        if (filterLanguage && filterLanguage.length <= 0 && supportedLanguage && supportedLanguage.length > 0) {
                            let isHaveSameLang = supportedLanguage.filter(
                                (sLang) => sLang.countryLanguageKey && computeLanguage && sLang.countryLanguageKey.substring(0, 2) === computeLanguage.substring(0, 2)
                            );

                            if (isHaveSameLang.length > 0) {
                                computeLanguage = gu_getNestedValue(isHaveSameLang, `0.countryLanguageKey`);
                            } else {
                                computeLanguage = gu_getNestedValue(supportedLanguage, `0.languages.0.countryLanguageKey`);
                            }
                        }
                    }

                    //computeLanguage correct de
                    if (!allowUserAccessOtherCurrency && localStorageLanguage !== computeLanguage) {
                        // Force it to go to /<correct language>/home instead of keeping old path
                        window.location.pathname = `/${computeLanguage.toLowerCase().replace('_', '-')}/home`;
                    }
                }

                languageListJson = languageListJson.filter((list) => list.currency === memberCurrency);
                if (setLanguage && vm && languageAction) {
                    core.setLanguageKeyAndCountryLanguage(vm, computeLanguage, languageAction);
                }

                if (!capitalCountryLanguage) {
                    langObj.previousLanguage = previousLanguage.toLowerCase().replace('_', '-');
                    langObj.computeLanguage = computeLanguage.toLowerCase().replace('_', '-');

                    resolve(langObj);
                    // return computeLanguage.toLowerCase().replace('_', '-');
                } else {
                    langObj.previousLanguage = previousLanguage;
                    langObj.computeLanguage = computeLanguage;
                    resolve(langObj);
                    // return computeLanguage;
                }
            });
        });
    },

    setLanguageKeyAndCountryLanguage(vm, countryLanguageKey, languageAction, updateUrl = false, backHomePage = false) {
        let languageDomain = null;

        const { isTranditionalZH } = vm?.props?.portal?.settings?.features || false;

        if (vm.props) {
            const portalSettings = gu_getNestedValue(vm, 'props.portalSettingsReducer.portalSettings');
            if (portalSettings) {
                if (!window.isAffiliate && portalSettings?.languageDomains) {
                    languageDomain = portalSettings?.languageDomains;
                } else if (window.isAffiliate && portalSettings?.affLanguageDomains) {
                    languageDomain = portalSettings?.affLanguageDomains;
                }
            }
            const extraLanguages = gu_getNestedValue(vm, 'props.portalSettingsReducer.portalSettings.features.extraLanguage.languages');
            if (extraLanguages) {
                for (let i = 0; i < extraLanguages.length; i++) {
                    if (countryLanguageKey === extraLanguages[i].countryLanguageKey) {
                        if (vm.props.screen.viewType === 'mobile') {
                            window.location.href = extraLanguages[i].url.mobile;
                            return;
                        } else {
                            window.location.href = extraLanguages[i].url.web;
                            return;
                        }
                    }
                }
            }
        }

        let key = countryLanguageKey.toLowerCase().split('_')[0];

        let checkIsTranditionalZH = false;
        const checkisTranditionalZHCurrencyBoolean = typeof isTranditionalZH?.[countryLanguageKey] === 'boolean';
        const checkTraditionalBooleanValue = isTranditionalZH?.[countryLanguageKey];
        const checkIsTranditionalZHBoolean = typeof isTranditionalZH === 'boolean';
        checkIsTranditionalZH =
            key === 'zh' &&
            isTranditionalZH &&
            (checkIsTranditionalZHBoolean ? isTranditionalZH : checkisTranditionalZHCurrencyBoolean ? checkTraditionalBooleanValue : false);

        if (countryLanguageKey === 'ZH_HK') {
            checkIsTranditionalZH = true;
            if (!checkIsTranditionalZHBoolean && checkisTranditionalZHCurrencyBoolean && !checkTraditionalBooleanValue) {
                checkIsTranditionalZH = true;
                if (checkTraditionalBooleanValue === false) {
                    checkIsTranditionalZH = false;
                }
            } else if (checkIsTranditionalZHBoolean && !checkisTranditionalZHCurrencyBoolean && isTranditionalZH === false) {
                checkIsTranditionalZH = false;
            }
        }

        switch (key) {
            case 'zh':
                key = checkIsTranditionalZH ? 'zh-HK' : 'zh-CN';

                break;
            case 'th':
                if (countryLanguageKey === 'TH_TH') {
                    key = 'th';
                }
                break;
            case 'ms':
                if (countryLanguageKey === 'MS_MY') {
                    key = 'ms';
                }
                break;
            case 'vi':
                if (countryLanguageKey === 'VI_VN') {
                    key = 'vi';
                }
                break;
            case 'id':
                if (countryLanguageKey === 'ID_ID') {
                    key = 'id';
                }
                break;
            case 'bn':
                if (countryLanguageKey === 'BN_BN') {
                    key = 'bn';
                }
                break;
            case 'km':
                if (countryLanguageKey === 'KM_KH') {
                    key = 'km';
                }
                break;
            case 'my':
                if (countryLanguageKey === 'MY_MM') {
                    key = 'my';
                }
                break;
            case 'tl':
                if (countryLanguageKey === 'TL_PH') {
                    key = 'tl';
                }
                break;
            case 'pt':
                if (countryLanguageKey === 'PT_BR') {
                    key = 'pt';
                }
                break;
            case 'ta':
                if (countryLanguageKey === 'TA_IN') {
                    key = 'ta';
                }
                break;
            case 'hi':
                if (countryLanguageKey === 'HI_IN') {
                    key = 'hi';
                }
                break;
            case 'ko':
                if (countryLanguageKey === 'KO_KH') {
                    key = 'ko';
                }
                break;
            case 'ja':
                if (countryLanguageKey === 'JA_KH') {
                    key = 'ja';
                }
                break;
            case 'kr':
                if (countryLanguageKey === 'KO_KR') {
                    key = 'kr';
                }
                break;
            case 'pg':
                if (countryLanguageKey === 'EN_PG') {
                    key = 'pg';
                }
                break;
            default:
                key = 'en';
                break;
        }

        window.SPL_Translation && window.SPL_Translation.initCurrentLanguage(key);
        vm.props.i18n.changeLanguage(key);

        vm.props.dispatch(languageAction.changeLanguage({ key, countryLanguageKey }));
        vm.props.dispatch(setCurrentLanguageByKey({ selectedLanguage: { key, countryLanguageKey } }));

        if (!window.isAgent && !window.isAffiliate) {
            if (window.SPL_LiteApp.isLiteApp()) {
                window.SPL_LiteApp.onLanguageChanged(countryLanguageKey.toLowerCase().replace('_', '-'));
            }
        }

        if (updateUrl) {
            const { history } = vm.props;
            const { portalSettings } = vm.props.portalSettingsReducer;
            const { features } = portalSettings;

            let showHomeWithoutUrl = gu_showHomeWithoutUrl(vm, features);
            let langPath = countryLanguageKey.replace('_', '-').toLowerCase();
            let hideLangPathUrl = gu_getNestedValue(features, 'hideLangPathUrl');

            let removeParamLang = gu_getNestedValue(features, 'removeParamLang');

            // check if got query string & enable for external social media that want to keep url query.
            let url = new URL(window.location.href);
            let searchParams = new URLSearchParams(url.search);
            let isSaveSearchParams = gu_getNestedValue(features, 'isSaveSearchParams');

            if (hideLangPathUrl) {
                // if got specified langPath (e.g. en-my), only hide that langPath. Used for default countryLanguage
                if (typeof hideLangPathUrl === 'object') {
                    hideLangPathUrl = portalSettings?.features?.hideLangPathUrl?.[langPath] ? true : false;
                }

                // additional option to remove ?lang=en-my param
                // only for hideLangPathUrl = true condition
                if (hideLangPathUrl && removeParamLang) {
                    if (typeof removeParamLang === 'object') {
                        removeParamLang = portalSettings?.features?.removeParamLang?.[langPath] ? true : false;
                    }
                }
            }

            let path = countryLanguageKey.replace('_', '-').toLowerCase();
            let historyPathname = gu_getNestedValue(history, 'location.pathname');
            if (historyPathname) {
                if (languageDomain && languageDomain[countryLanguageKey]) {
                    let urlParam = languageDomain[countryLanguageKey];
                    let langKey = countryLanguageKey.replace('_', '-').toLowerCase();
                    let path = backHomePage ? '/home' : historyPathname;
                    let jwt = window.SPL_Cookie.getCookie('t');
                    if (urlParam) {
                        let queryParams = '?langCode=' + langKey + '&path=' + path;
                        if (jwt) queryParams += '&t=' + jwt;
                        window.location.href = urlParam + queryParams;
                    }
                } else {
                    if (backHomePage) {
                        if (hideLangPathUrl) {
                            if (removeParamLang) {
                                setTimeout(function () {
                                    window.location.href = showHomeWithoutUrl ? '/' : `/home`;
                                }, 750);
                            } else {
                                window.location.href = (showHomeWithoutUrl ? '/' : `/home`) + '?lang=' + path;
                            }
                        } else {
                            window.location.href = showHomeWithoutUrl ? `/${path}/` : `/${path}/home`;
                        }
                    } else {
                        if (hideLangPathUrl) {
                            if (removeParamLang) {
                                setTimeout(function () {
                                    window.location.href = historyPathname;
                                }, 750);
                            } else {
                                window.location.href = historyPathname + '?lang=' + path;
                            }
                        } else if (isSaveSearchParams) {
                            window.location.href = `/${path}${historyPathname}?${searchParams.toString()}`;
                        } else {
                            window.location.href = `/${path}` + historyPathname;
                        }
                    }
                }
            }
        }
    },

    copy(t, text) {
        return gu_copy(t, text);
    },

    async pasteClipboard() {
        try {
            const text = await navigator.clipboard.readText();
            return text;
        } catch (err) {
            console.error('Failed to read clipboard contents: ', err);
            return null;
        }
    },

    openLivechat(countryLanguageKey, viewType, liveChatToLine) {
        window.SPL_Content.getContact(countryLanguageKey, viewType).then((data) => {
            let contactObj = null;
            if (data) {
                for (let i = 0; i < data.length; i++) {
                    if (liveChatToLine && data[i].name === 'Line') {
                        contactObj = data[i];
                        break;
                    } else if (!liveChatToLine && data[i].name === 'LiveChat') {
                        contactObj = data[i];
                        break;
                    }
                }
            }
            if (contactObj) {
                window.SPL_Content.getContactUrl(contactObj, liveChatToLine);
            }
        });
    },

    replaceAll(str, search, replacement) {
        return str.replace(new RegExp(search, 'g'), replacement);
    },

    getComponentClass(oriClassName, key) {
        if (window[key]) {
            return oriClassName + ' ' + window[key];
        } else {
            return oriClassName;
        }
    },

    changeClassName(oriClassName, key) {
        if (window[key]) {
            return window[key];
        } else {
            return oriClassName;
        }
    },

    executeFunctionList(customFunctionList) {
        if (customFunctionList && customFunctionList.length) {
            customFunctionList.forEach((customFunction) => {
                if (typeof customFunction === 'function') {
                    customFunction();
                }
            });
        }
    },

    logout(vm) {
        vm.props.dispatch(userAction.logout()).then(() => {
            if (!window.isAgent && !window.isAffiliate) {
                if (window.SPL_LiteApp.isLiteApp()) {
                    window.SPL_LiteApp.onLogoutTapped();
                }
            }

            let path = '/';
            let langKey = '';
            let pathname = window.location.pathname;
            let pathArray = pathname.split('/');

            if (pathArray && pathArray.length >= 2 && pathArray[1].indexOf('-') !== -1) {
                langKey = pathArray[1];
            } else if (vm.props && vm.props.language && vm.props.language.countryLanguageKey) {
                langKey = vm.props.language.countryLanguageKey.toLowerCase().replace('_', '-');
            } else if (window && window.countryLanguageKey) {
                langKey = window.countryLanguageKey.toLowerCase().replace('_', '-');
            }

            path = '/' + langKey;

            if (window.isAffiliate) {
                path += '/aff';
            } else {
                /**
                 * TODO: investigate issue cannot load on iOS mobile
                 * Temporary fix by mobileForceRedirectHome
                 */
                if (window.mobileForceRedirectHome && vm.props?.screen?.isMobile) {
                    path += '/home';
                }
            }

            window.location.href = path;

            // clear storage for react tour deposit
            const isFirstRegister = window.localStorage.getItem('isFirstRegister');
            if (isFirstRegister) {
                window.localStorage.removeItem('isFirstRegister');
            }
            const finishedStepTutorial = window.localStorage.getItem('finishedStepTutorial');
            if (finishedStepTutorial) {
                window.localStorage.removeItem('finishedStepTutorial');
            }
            const hideExclusiveMissionPopupStorage = window.localStorage.getItem('hideExclusiveMissionPopupStorage');
            if (hideExclusiveMissionPopupStorage) {
                window.localStorage.removeItem('hideExclusiveMissionPopupStorage');
            }
        });
    },

    portalIsLoading(props, flag, showLoadingContent) {
        props.dispatch(portalAction.portalIsLoading(flag, showLoadingContent));
    },

    downloadUrl(url, name) {
        let link = document.createElement('a');
        link.download = name;
        link.href = url;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        link = null;
    },

    getSocialMediaShare(referralSettings, media) {
        let url = '';
        let link = '';

        if (referralSettings && referralSettings.referralSetting && referralSettings.referralSetting.referralLink) {
            link = referralSettings.referralSetting.referralLink;
        }

        switch (media) {
            case 'Skype':
                url = link || 'https://web.skype.com';
                break;

            default:
                return;
        }

        window.open(url, 'popUpWindow', 'height=500,width=400,left=100,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes');
    },

    getCorrectBankIcon(bankCode, vm, isSvg) {
        const bankIconPrefix = isSvg ? 'bank_' : 'icon-bank_';
        if (bankCode) {
            switch (bankCode.toLowerCase()) {
                case 'scb':
                    if (vm.props.user.account.currency === 'MYR') {
                        return bankIconPrefix + 'scb_myr';
                    } else {
                        return bankIconPrefix + 'scb';
                    }
                default:
                    if (bankCode.toLowerCase().includes('other')) {
                        bankCode = 'other';
                    }
                    return bankIconPrefix + bankCode.toLowerCase();
            }
        }
        return bankIconPrefix;
    },

    getMerchantMiniGameLink(props) {
        const { language, portalSettingsReducer } = props;
        core.portalIsLoading(props, true);

        if (portalSettingsReducer?.portalSettings?.customMiniGameURL) {
            core.portalIsLoading(props, false);

            window.open(portalSettingsReducer?.portalSettings?.customMiniGameURL, '_blank');
        } else {
            var wi = window.open('about:blank', '_blank'); // open blank page first to bypass safari blocked
            window.SPL_Content.getMerchantMiniGameLink(language.countryLanguageKey).then((url) => {
                core.portalIsLoading(props, false);
                if (url) {
                    wi.location.href = url;
                }
            });
        }
    },
};

export default core;

/**
 *
 * @param {object} portalSetting - redux portal.settings
 * @returns languageDomain - To determine Affiliate or Money domain
 */
export const getPortalSettingURL = (portalSetting) => {
    const { languageDomains, affLanguageDomains } = portalSetting;
    let languageDomain;

    if (!window.isAffiliate && languageDomains) {
        languageDomain = languageDomains;
    } else if (window.isAffiliate && affLanguageDomains) {
        languageDomain = affLanguageDomains;
    }

    return languageDomain;
};

/**
 *
 * @param {string} historyPathname - react-router-dom history.location.pathname
 * @param {object} settingFeatures - redux portal-setting portal.settings.features
 * @param {string} languageKey - select language key EN_MY and convert to en-my before pass in, normally call countryLanguageKey in languageReducer
 * @param {string} languageDomain - get value from getPortalSettingURL()
 * @param {boolean} backHomePage - *TBC, currently only 1 place i calling this at change-language.controller.js
 */
export const updateURL = (historyPathname, settingFeatures, languageKey, languageDomain, backHomePage) => {
    const { showHomeWithoutUrl, hideLangPathUrl, removeParamLang } = settingFeatures;
    const countryLanguageKey = languageKey?.replace('-', '_')?.toUpperCase();
    let isHideLangPathUrl;
    let isRemoveParamLang;
    if (hideLangPathUrl) {
        // if got specified langPath (e.g. en-my), only hide that langPath. Used for default countryLanguage
        if (typeof hideLangPathUrl === 'object') {
            isHideLangPathUrl = hideLangPathUrl[languageKey] ? true : false;
        }

        // additional option to remove ?lang=en-my param
        // only for hideLangPathUrl = true condition
        if (isHideLangPathUrl && removeParamLang) {
            if (typeof removeParamLang === 'object') {
                isRemoveParamLang = removeParamLang[languageKey] ? true : false;
            }
        }
    }

    if (historyPathname) {
        if (languageDomain && languageDomain[countryLanguageKey]) {
            let urlParam = languageDomain[countryLanguageKey];
            const path = backHomePage ? '/home' : historyPathname;
            let jwt = window.SPL_Cookie.getCookie('t');
            if (urlParam) {
                let queryParams = '?langCode=' + languageKey + '&path=' + path;
                if (jwt) queryParams += '&t=' + jwt;
                window.location.href = urlParam + queryParams;
            }
        } else {
            if (backHomePage) {
                if (isHideLangPathUrl) {
                    if (isRemoveParamLang) {
                        setTimeout(function () {
                            window.location.href = showHomeWithoutUrl ? '/' : `/home`;
                        }, 750);
                    } else {
                        window.location.href = (showHomeWithoutUrl ? '/' : `/home`) + '?lang=' + languageKey;
                    }
                } else {
                    window.location.href = showHomeWithoutUrl ? `/${languageKey}/` : `/${languageKey}/home`;
                }
            } else {
                if (isHideLangPathUrl) {
                    if (isRemoveParamLang) {
                        setTimeout(function () {
                            window.location.href = historyPathname;
                        }, 750);
                    } else {
                        window.location.href = historyPathname + '?lang=' + languageKey;
                    }
                } else {
                    window.location.href = `/${languageKey}` + historyPathname;
                }
            }
        }
    }
};
